var map = {
	"./en_US2.png": "GMIf",
	"./zh_CN2.png": "eK14",
	"./zh_HANT2.png": "7bGL"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "pDLR";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile ^\.\/.*2\.png$
// module id = pDLR
// module chunks = 1